'use client';

import React from 'react';
// import { BestieBanner } from '@components/templates/landing/BestieBanner';
import { MyInterviewsSection } from '@components/templates/job/list/MyInterviewsSection';
import { useIsClient } from '@hooks/useIsClient';

// --- Component Interface ---
interface JobListBannersProps {
  isAuthenticated: boolean;
  locale: Locale;
  hasAppliedFilters: boolean;
}

/**
 * @description Wrapper component to defer rendering of client-side banners
 * until after hydration. This stabilizes the server-rendered DOM.
 */
export const JobListBanners = (props: JobListBannersProps) => {
  const {
    isAuthenticated,
    locale,
    hasAppliedFilters,
  } = props;

  const isClient = useIsClient();

  if (!isClient) {
    // Stable placeholder
    return <div className="py-2" />;
  }

  // Now we safely render the dynamic components.
  return (
    <>
      {/* Bestie Banner */}
      {/* {!hasAppliedFilters && (
      <BestieBanner />
      )} */}

      {/* My Interviews Section */}
      {isAuthenticated && !hasAppliedFilters && (
        <div className="py-2">
          {/* My Interviews Section - only for authenticated users */}
          <MyInterviewsSection locale={locale} />
        </div>
      )}
    </>
  );
};
